import React from "react";
import ScrollToTopButton from "./scroll-to-top/ScrollToTopButton";
import useScrollToTopButton from "./scroll-to-top/useScrollToTopButton";

export default function PageLayout({
  children,
  enableScrollToTop = false,
  modernShell = false,
}) {
  const { isVisible, scrollToTop } = useScrollToTopButton();

  if (modernShell) {
    return (
      <div className="page-layout page-layout--modern-shell">
        {enableScrollToTop ? (
          <ScrollToTopButton isVisible={isVisible} onClick={scrollToTop} />
        ) : null}
        <div className="rp-page-layout__content">{children}</div>
      </div>
    );
  }

  return (
    <div className="page-layout">
      {enableScrollToTop ? (
        <ScrollToTopButton isVisible={isVisible} onClick={scrollToTop} />
      ) : null}
      <div className="page-content">{children}</div>
    </div>
  );
}
